import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { useEffect, useState } from "react";
import { getCatalogResultSources } from "../../repositories/CatalogResultSourceRepository";
import { useCatalogResultSourceContext } from "./CatalogResultSourceContext";
import { TableResultSource } from "./components/TableResultSource";

type Props = {};
export const CatalogResultSourcePage = (props: Props) => {
	const { state, actions } = useCatalogResultSourceContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogResultSourcesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogResultSources();
		if (resp.ok) {
			actions.setResultSources(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogResultSourcesFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.resultSources) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableResultSource
								isLoading={isLoading}
								getCatalogResultSourcesFromAPI={getCatalogResultSourcesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			item
			xs={12}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
